/* eslint-disable no-empty-pattern */
import axios from "axios";

const state = {};

const getters = {};

const actions = {
  async storeContent({ commit }, payload) {
    try {
      const res = await axios.post(
        process.env.VUE_APP_API_URL + "/konten/create.php",
        payload
      );
      commit("SET_SNACKBAR", {
        visibility: true,
        color: res.data.success ? "success" : "error",
        text: res.data.message
      });
      return res.data.success;
    } catch (err) {
      commit("SET_SNACKBAR", {
        visibility: true,
        color: "error",
        text: err
      });
      return false;
    }
  },
  async storeFile({ commit }, payload) {
    try {
      const res = await axios.post(
        process.env.VUE_APP_API_URL + "/konten/upload.php",
        payload
      );
      commit("SET_SNACKBAR", {
        visibility: true,
        color: res.data.success ? "success" : "error",
        text: res.data.message
      });
      return res.data.success;
    } catch (err) {
      commit("SET_SNACKBAR", {
        visibility: true,
        color: "error",
        text: err
      });
      return false;
    }
  },
  async storeReview({ commit }, payload) {
    try {
      const res = await axios.post(
        process.env.VUE_APP_API_URL + "/review/create.php",
        payload
      );
      commit("SET_SNACKBAR", {
        visibility: true,
        color: res.data.success ? "success" : "error",
        text: res.data.message
      });
      return res.data.success;
    } catch (err) {
      commit("SET_SNACKBAR", {
        visibility: true,
        color: "error",
        text: err
      });
      return false;
    }
  },
  async getFiles({}, payload) {
    try {
      const res = await axios.get(
        process.env.VUE_APP_API_URL +
          "/konten/file_list.php?subkriteria=" +
          payload
      );
      return res.data;
    } catch (e) {
      return [];
    }
  },
  async getContents({}, payload) {
    try {
      const res = await axios.get(
        process.env.VUE_APP_API_URL +
          "/konten/get_by.php?subkriteria=" +
          payload
      );
      return res.data;
    } catch (e) {
      return null;
    }
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
